let slidesBtn = document.querySelector(".slides__btn");

if (slidesBtn) {
	slidesBtn.addEventListener("click", () => {
		let target = document.querySelector(`.stories__item[data-id="${slidesBtn.dataset.id}"]`);

		if (target) {
			target.click();
		}
	});
}

let stories = document.querySelectorAll(".stories__item");
let storiesPopup = document.querySelector(".stories__popup");
let storiesPopupClose = document.querySelector(".stories__popupClose");
let storiesList = document.querySelector(".stories__popupList");
let storiesVideos;
if (storiesPopup) {
	storiesVideos = storiesPopup.querySelectorAll("video");
}
let storiesListCarousel;

if (storiesList) {
	storiesListCarousel = new Flickity(storiesList, {
		cellAlign: "center",
		prevNextButtons: false,
		pageDots: false,
		watchCSS: false,
		imagesLoaded: true,
		freeScroll: false,
	});

	storiesListCarousel.on("change", (index) => {
		storiesVideos.forEach((item) => {
			item.pause();
			item.currentTime = 0;
			if (item.closest(".is-selected")) {
				item.play();
			}
		});
	});
}

if (stories.length) {
	stories.forEach((item) => {
		item.addEventListener("click", () => {
			document.body.classList.add("scrollOff");
			storiesPopup.classList.add("stories__popup--active");

			let currentId = item.dataset.id;
			let target = storiesPopup.querySelector(`.stories__popupItem[data-id="${currentId}"]`);
			let video = target.querySelector("video");

			storiesListCarousel.select(currentId - 1);
			video.play();

			storiesVideos.forEach((story) => {
				story.addEventListener("ended", showNextStory);
			});
		});
	});

	storiesPopupClose.addEventListener("click", () => {
		document.body.classList.remove("scrollOff");
		storiesPopup.classList.remove("stories__popup--active");

		storiesVideos.forEach((item) => {
			item.pause();
			item.currentTime = 0;

			item.removeEventListener("ended", showNextStory);
		});
	});
}

function showNextStory() {
	if (storiesListCarousel.selectedIndex == storiesListCarousel.slides.length - 1) {
		storiesPopupClose.click();
	} else {
		storiesListCarousel.select(storiesListCarousel.selectedIndex + 1);
	}
}

let storiesCta = document.querySelectorAll(".stories__popupItemCta");

storiesCta.forEach((item) => {
	item.addEventListener("click", (evt) => {
		evt.preventDefault();
		storiesPopupClose.click();

		document.body.classList.add("scrollOff");

		formOverlay.classList.add("formOverlay--visible");
		form.classList.add("form--visible");

		form.querySelector(".form__heading span").innerText = form.dataset.common;
	});
});
